import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types"

const maxAuthorsForImages = 3

export function shouldShowAuthorImages(
  model: ArticleContentModel.Byline,
): boolean {
  return (
    model.class === "author" &&
    model.authors.some((author) => author.imageUrl !== null)
  )
}

export function getAuthorImageClasses(
  model: ArticleContentModel.Byline,
): string {
  if (model.class !== "author") {
    return ""
  }

  const authorCount = model.authors.length

  if (authorCount > 2) {
    if (authorCount === maxAuthorsForImages) {
      return "hidden md:block"
    }
    return "hidden"
  }
  return ""
}

export function getAuthors(
  model: ArticleContentModel.Byline,
): ReadonlyArray<ArticleContentModel.Author> {
  if (model.class === "author") {
    return model.authors
  }
  return []
}

export function getAuthorImageZIndex(
  model: ArticleContentModel.Byline,
  hoveredAuthorIndex: number | null,
  index: number | null,
): number {
  if (model.class !== "author" || index === null) {
    return 0
  }

  if (hoveredAuthorIndex === index) {
    return model.authors.length + 10
  }
  return model.authors.length - index
}

export function getHoveredTransform(isHovered: boolean): string {
  return isHovered ? "translateY(-2px)" : "translateY(0)"
}

const namePartsRegex = /\s+/g

export function getInitials(name: string): string {
  const trimmedName = name.trim()

  if (!trimmedName) {
    return "?"
  }

  const parts = trimmedName.split(namePartsRegex)
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase()
  }
  const firstInitial = parts[0][0] || ""
  const lastInitial = parts[parts.length - 1][0] || ""

  return (firstInitial + lastInitial).toUpperCase()
}
